import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'

import { Checkbox, TextInput, Button, FormControl } from 'components'

import type { ILoginForm } from './model'
import { useTranslation } from 'react-i18next'

function LoginForm(props: ILoginForm): JSX.Element {
  const { onSubmit } = props
  const { handleSubmit, control, errors, formState } = useFormContext()
  const { t } = useTranslation('login')
  const { isSubmitting } = formState

  return (
    <form onSubmit={handleSubmit(onSubmit)} className='f-login-form'>
      <FormControl
        label={t('username.label')}
        className='f-login-form__form-control'
      >
        <Controller
          as={TextInput}
          type='text'
          name='email'
          control={control}
          placeholder={t('username.placeholder')}
          isError={Boolean(errors.email?.message)}
          message={errors.email?.message}
        />
      </FormControl>
      <FormControl
        label={t('password.label')}
        className='f-login-form__form-control'
      >
        <Controller
          as={TextInput}
          control={control}
          type='password'
          name='password'
          placeholder={t('password.placeholder')}
          isError={Boolean(errors.password?.message)}
          message={errors.password?.message}
        />
      </FormControl>

      <div className='f-login-form__row'>
        <Controller
          control={control}
          name='isRemember'
          render={({ onChange, value, name }) => {
            return (
              <Checkbox
                name={name}
                label={t('rememberMe')}
                onChange={(checked) => onChange(checked)}
                checked={value}
                disabled={isSubmitting}
              />
            )
          }}
        />
        <Button href='#' className='f-login-form__forgot-password'>
          {t('forgotPassword')}
        </Button>
      </div>
      <Button
        type='submit'
        className='f-login-form__submit'
        disabled={isSubmitting}
      >
        {t('login')}
      </Button>
    </form>
  )
}

export default LoginForm
